// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class PublishMapAction implements flatbuffers.IUnpackableObject<PublishMapActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PublishMapAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPublishMapAction(bb:flatbuffers.ByteBuffer, obj?:PublishMapAction):PublishMapAction {
  return (obj || new PublishMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPublishMapAction(bb:flatbuffers.ByteBuffer, obj?:PublishMapAction):PublishMapAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PublishMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapPublishMap;
}

static startPublishMapAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapPublishMap);
}

static endPublishMapAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPublishMapAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  PublishMapAction.startPublishMapAction(builder);
  PublishMapAction.addType(builder, type);
  return PublishMapAction.endPublishMapAction(builder);
}

unpack(): PublishMapActionT {
  return new PublishMapActionT(
    this.type()
  );
}


unpackTo(_o: PublishMapActionT): void {
  _o.type = this.type();
}
}

export class PublishMapActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapPublishMap
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return PublishMapAction.createPublishMapAction(builder,
    this.type
  );
}
}
